<template>
  <b-modal @close="clear" :active="visible" has-modal-card :can-cancel="false">
    <div class="modal-card" style="height: calc(100vh - 40px)">
      <div class="modal-card-head">
        <p class="modal-card-title">{{ $t("Find terms") }}</p>
      </div>
      <div class="modal-card-body">
        <LiquorTree ref="tree" :data="treeData" :options="options" />
      </div>
      <div class="modal-card-foot">
        <Level style="width: 100%">
          <template #left>
            <b-button @click="clear">{{ $t("Clear selections") }}</b-button>
          </template>
          <template #right>
            <b-button @click="cancel" style="margin-right: 0.75rem">
              {{ $t("Cancel") }}
            </b-button>
            <b-button type="is-primary" @click="submit">
              {{ $t("Paste terms") }}
            </b-button>
          </template>
        </Level>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss">
@import "@/assets/variables.scss";

.tree-checkbox.checked,
.tree-checkbox.indeterminate {
  background-color: $primary;
  border-color: darken($primary, 10%);
}

/* FIXTHIS: hack for removing checkbox from non-leaf nodes */
.tree {
  .tree-node.has-child {
    & > .tree-content {
      & > .tree-checkbox {
        display: none;
      }
    }
  }
}
</style>

<script>
import LiquorTree from "liquor-tree";

import Level from "@/components/Level.vue";

const treeData = require("@/assets/search-terms.json");

export default {
  components: {
    Level,
    LiquorTree,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tree: null,
      options: { multiple: true, checkbox: true },
    };
  },
  computed: {
    treeData() {
      return treeData.map((item) => ({
        text: item.labels[this.currentLocale],
        state: { selectable: false },
        children: item.children.map((item) => ({
          text: item.labels[this.currentLocale],
          state: { selectable: false },
          children: item.terms.map((term) => ({
            text: term,
            data: { term: true, value: term },
            state: { selectable: false },
          })),
        })),
      }));
    },
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    clear() {
      if (this.$refs.tree) {
        this.$refs.tree.findAll({ state: { checked: true } }).uncheck();
        this.$refs.tree.findAll({ state: { expanded: true } }).collapse();
      }
    },
    
    submit() {
      if (this.$refs.tree) {
        const checked = this.$refs.tree.findAll({
          data: { term: true },
          state: { checked: true },
        });
        if (checked.length > 0) {
          this.$emit(
            "input",
            checked.map((item) => item.data.value)
          );
        }
        this.clear();
        this.$emit("update:visible", false);
      }
    },
    cancel() {
      this.clear();
      this.$emit("update:visible", false);
    },
  },
};
</script>
